import { Typography, Container, Row } from '@ag1/ui';
import { vars } from '@ag1/ui/theme';
import clsx from 'clsx';
import { ComparisonCards as ComparisonCardsProps, SanityKeyed } from 'types/studio/studio';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import { CommonSectionProps } from '../types';
import { ComparisonCard } from './ComparisonCard/ComparisonCard';
import * as styles from './ComparisonCards.css';

const ComparisonCards = (props: SanityKeyed<ComparisonCardsProps> & CommonSectionProps) => {
  const {
    _key: key,
    subtitle,
    headline,
    sectionBackgroundColor,
    leftCard,
    rightCard,
    padding,
    visibleOnPageLoad
  } = props;

  const { colors } = vars;
  const getBackgroundColor = (backgroundColor?: string) => {
    if (!backgroundColor) return colors.background.white;
    const colorMap: Record<string, string> = {
      agzPrimary: colors.background.agzPrimary,
      blackSecondary: colors.background.blackSecondary,
      greenPrimary: colors.background.greenPrimary,
      greenSecondary: colors.background.greenSecondary,
      stone: colors.background.stone,
      stoneLight: colors.background.stoneLight,
      white: colors.background.white
    };
    return colorMap[backgroundColor] || colors.background.white;
  };

  const isDarkTheme =
    sectionBackgroundColor === 'agzPrimary' ||
    sectionBackgroundColor === 'blackSecondary' ||
    sectionBackgroundColor === 'greenPrimary' ||
    sectionBackgroundColor === 'greenSecondary';

  return (
    <div
      className={clsx(getSectionPaddingClasses(styles, padding))}
      style={{ backgroundColor: getBackgroundColor(sectionBackgroundColor) }}
      id={key}>
      <Container narrow>
        <Row className={styles.row}>
          {(headline || subtitle) && (
            <div className={styles.headlineContainer}>
              <Typography
                variant="headlineSans"
                size="1"
                component="h2"
                color={isDarkTheme ? 'brand-white' : 'black-new'}
                noPadding
                className={styles.headline}>
                {headline}
              </Typography>
              {subtitle && (
                <Typography
                  variant="subtitle"
                  size="1"
                  component="h3"
                  noPadding
                  color={isDarkTheme ? 'brand-white' : 'black-new'}
                  className={styles.subtitle}>
                  {subtitle}
                </Typography>
              )}
            </div>
          )}
          <div className={styles.cardsContainer}>
            <ComparisonCard {...leftCard} visibleOnPageLoad={visibleOnPageLoad} />
            <ComparisonCard {...rightCard} visibleOnPageLoad={visibleOnPageLoad} />
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default ComparisonCards;
